import axios from 'axios';
import { useEffect, useState } from 'react';

import { getAxios } from './get-axios';

const bufferUrlAndObject: { [key: string]: any } = {};

export const useLoadingProtectUrl = (url: string, token: string /* mode: 'link' | 'download'='link' */) => {
    const [data, setData] = useState('');
    const [isInFlight, setIsInFlight] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                if (!bufferUrlAndObject[url] && !url.includes('/undefined/')) {
                    setIsInFlight(true);

                    const signedUrlResponse = await getAxios().get(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    const signedUrl = signedUrlResponse.data.signedUrl;

                    // Don't use axios instance as we don't want Authorization header to be passed
                    const response = await axios.get(signedUrl, {
                        responseType: 'blob',
                        headers: {
                            Accept: '*/*',
                        },
                    });

                    bufferUrlAndObject[url] = URL.createObjectURL(response.data);
                }

                setIsInFlight(false);
                setData(bufferUrlAndObject[url]);

                // return new Blob([response.data], { type: 'application/pdf' });

                // Create a temporary URL for the blob
                // return URL.createObjectURL(response.data);
                // const blobUrl = URL.createObjectURL(response.data);
                // Create and click an <a download> link
                // const link = document.createElement('a');
                // link.href = blobUrl;
                // link.download = 'filename.pdf'; // set desired file name
                // document.body.appendChild(link);
                // link.click();
                // link.remove();
                // // Release the blob URL
                // URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error('Download error:', error);
                setIsInFlight(false);
            }
        })();
    }, [url, token]);

    return { data, isInFlight };
};
